import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Deja entrar a quien tiene sesión, incluida la que llega por enlace desde otra solución:
 * ese enlace trae el workspace en la url y la sesión en la cookie del dominio, así que se
 * intenta abrir con eso antes de mandar a nadie al formulario.
 */
export const authGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (await authService.aplicarSesionDeEnlace()) {
    return true;
  }

  return router.parseUrl('/login');
};
